// import { useState, useEffect, useCallback } from 'react';

// const cache = new Map();

// export const useCachedFetch = (url) => {
//   let apiUrl = url;
//   if (url.startsWith('/data/locales/')) {
//     const filename = url.replace('/data/locales/', '').replace('.json', '');

//     apiUrl = process.env.NODE_ENV === 'development'
//       ? `http://localhost:5001/api/content/${filename}`
//       : `/api/content/${filename}`;
//   }

//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [version, setVersion] = useState(0);

//   const fetchData = useCallback(async (force = false) => {
//     if (!force && cache.has(apiUrl)) {
//       setData(cache.get(apiUrl));
//       setLoading(false);
//       setError(null);
//       return;
//     }

//     setLoading(true);
//     setError(null);

//     try {
//       const response = await fetch(apiUrl);
//       if (!response.ok) throw new Error(`HTTP ${response.status}`);

//       const newData = await response.json();
//       cache.set(apiUrl, newData);
//       setData(newData);
//     } catch (err) {
//       setError(err);
//     } finally {
//       setLoading(false);
//     }
//   }, [apiUrl]);

//   useEffect(() => {
//     fetchData();
//   }, [fetchData, version]);

//   const refetch = useCallback(() => {
//     setVersion(v => v + 1);
//   }, []);

//   return {
//     data,
//     loading,
//     error,
//     refetch
//   };
// };




import { useState, useEffect, useCallback } from 'react';

const cache = new Map();

const API_BASE_URL = 'https://carabinex.onrender.com';

export const useCachedFetch = (url) => {
  let apiUrl = url;
  
  if (url.startsWith('/data/locales/')) {
    const filename = url.replace('/data/locales/', '').replace('.json', '');
    apiUrl = `${API_BASE_URL}/api/content/${filename}`;
  } else if (url.startsWith('/api/')) {
    apiUrl = `${API_BASE_URL}${url}`;
  }

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [version, setVersion] = useState(0);

  const fetchData = useCallback(async (force = false) => {
    if (!force && cache.has(apiUrl)) {
      setData(cache.get(apiUrl));
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await fetch(apiUrl);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const newData = await response.json();
      cache.set(apiUrl, newData);
      setData(newData);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [apiUrl]);

  useEffect(() => {
    fetchData();
  }, [fetchData, version]);

  const refetch = useCallback(() => {
    setVersion(v => v + 1);
  }, []);

  return {
    data,
    loading,
    error,
    refetch
  };
};